module.exports = __webpack_public_path__ + "static/media/mika-baumeister-Hi4Ak40cy3g-unsplash.0b21bd8c.jpg";